import { render, staticRenderFns } from "./CaptchaPop.vue?vue&type=template&id=3a3131cd&scoped=true&"
import script from "./CaptchaPop.vue?vue&type=script&lang=js&"
export * from "./CaptchaPop.vue?vue&type=script&lang=js&"
import style0 from "./CaptchaPop.vue?vue&type=style&index=0&id=3a3131cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3131cd",
  null
  
)

export default component.exports